import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { Response } from './Types';

/**
 * Devolução ao fornecedor — o registro logístico.
 *
 * O `ErroDetalhado` é repassado sempre que existe, e não é detalhe de implementação: a
 * API coloca ali a mensagem crua da procedure, que foi escrita em português para o
 * operador — "a quantidade a devolver é maior que o saldo devolvível deste item", "esta
 * nota foi lançada sem XML e não tem chave de acesso". Trocar por um texto genérico aqui
 * apagaria justamente a informação que resolve o problema dele.
 */
class DevolucaoFornecedorController {
  /** Tela 1: as notas de entrada em que o produto aparece, com o saldo devolvível. */
  public static async Consultar(request: any): Promise<Response> {
    try {
      const response = await Api.post('api/DevolucaoFornecedor/Consultar', request);
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }

  /** Tela 2: cria o registro em PENDENTE. Devolve `dvf_id` e `saldo_restante`. */
  public static async Gravar(request: any): Promise<Response> {
    try {
      const response = await Api.post('api/DevolucaoFornecedor/Gravar', request);
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }

  /** Cancela o registro. A quantidade volta ao saldo; a linha não é apagada. */
  public static async Cancelar(dvfId: number): Promise<Response> {
    try {
      const response = await Api.post(`api/DevolucaoFornecedor/Cancelar/${dvfId}`);
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }

  /**
   * Tela 4: o que a nota VAI ser. Não grava nada.
   *
   * Devolve `{ Cabecalho, Itens }`. O cabeçalho traz os impedimentos já resolvidos
   * (`impede_*`) e um aviso que NÃO impede (`aviso_estoque_menor`) — a tela desabilita o
   * botão e mostra o motivo, em vez de reimplementar a regra.
   */
  public static async Previa(dvfIds: number[]): Promise<Response> {
    try {
      const response = await Api.post('api/DevolucaoFornecedor/Previa', { DvfIds: dvfIds });
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }

  /**
   * Tela 4: grava a nota fiscal da devolução. NÃO transmite — transmitir continua sendo a
   * Rotina de Nota Fiscal, que já existe.
   *
   * A resposta vem lida do banco: número, finalidade, tipo, CFOPs, CSOSN e totais.
   */
  public static async GerarNotaFiscal(request: any): Promise<Response> {
    try {
      const response = await Api.post('api/DevolucaoFornecedor/GerarNotaFiscal', request);
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }

  /** Os registros já criados. Por padrão só os disponíveis (PENDENTE). */
  public static async Listar(request: any): Promise<Response> {
    try {
      const response = await Api.post('api/DevolucaoFornecedor/Listar', request);
      return { StatusCode: response.status, Data: response?.data, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro ?? undefined,
      };
    }
  }
}

export default DevolucaoFornecedorController;
